module.exports = __webpack_public_path__ + "img/ltl-2.5beeebb4.png";